// 固件列表查询
const QueryForm = {
    labelCol: { style: { width: '100px' } },
    wrapperCol: { span: 14 },
    formData:{},
    formField:[
        {
            // name:'姓名',
            key:'user_name',
            type:'input',
            allowClear:true,
            width:'180px',
            placeholder_lang:'按账号查询',
        },
        {
            // name:'状态',
            key:'status',
            type:'select',
            allowClear:true,
            width:'180px',
            placeholder_lang:'按状态查询',
            options:[
                {
                    label:'正常',
                    value:0,
                },
                {
                    label:'禁用',
                    value:2,
                },
            ]
        },
        {
            // name:'状态',
            key:'app_id',
            type:'select',
            allowClear:true,
            width:'180px',
            placeholder_lang:'按小程序查询',
            options:[]
        },
        {
            // name:'状态',
            key:'customer_code',
            type:'select',
            allowClear:true,
            width:'180px',
            placeholder_lang:'按客户查询',
            options:[]
        },
        {
            // name:'状态',
            key:'role_type',
            type:'select',
            allowClear:true,
            width:'180px',
            placeholder_lang:'按角色类型查询',
            options:[
                {
                    label:'后台管理员',
                    value:0,
                },
                {
                    label:'公告发布人员',
                    value:1,
                },
                {
                    label:'文件管理人员',
                    value:2,
                },
            ]
        },
        {
            // name:'状态',
            key:'user_type',
            type:'select',
            allowClear:true,
            width:'180px',
            placeholder_lang:'按用户类型查询',
            options:[
                {
                    label:'后台用户',
                    value:1,
                },
                {
                    label:'APP用户',
                    value:0,
                },
            ]
        },
    ]
}

// 新增版本
const AddForm = {
    labelCol: { style: { width: '120px' } },
    wrapperCol: { span: 14 },
    formData:{},
    formField:[
        {
            name_lang:'appVersion.tenant_name',
            key:'teanant_id',
            type:'select',
            placeholder:'请选择',
            placeholder_lang:'base.select',
            disabled:false,
            required:true,
            width:'400px',
            options:[],
        },
        {
            name_lang:'appVersion.platform',
            key:'platform',
            type:'select',
            placeholder:'请选择',
            placeholder_lang:'base.select',
            disabled:false,
            required:true,
            width:'400px',
            options:[
                {
                    label:'appVersion.Android',
                    value:'Android',
                },
                {
                    label:'appVersion.iOS',
                    value:'iOS',
                },
            ],
        },
        {
            name_lang:'appVersion.platform_path',
            key:'platform_path',
            type:'input',
            allowClear:true,
            required:true,
            placeholder:'请输入',
            placeholder_lang:'base.enter',
            width:'400px',
        },
        {
            name_lang:'appVersion.current_version',
            key:'current_version',
            type:'input',
            allowClear:true,
            disabled:false,
            required:true,
            width:'400px',
            placeholder_lang:'appVersion.current_version_eg',
        },
        {
            name_lang:'appVersion.alert_flag',
            key:'alert_flag',
            type:'radio',   
            allowClear:true,
            required:true,
            options:[
                { label: 'YES', value: 0 },
                { label: 'NO', value: 1 },
            ]
        },
    ]
}

QueryForm.formField.forEach(item=>{
    QueryForm.formData[item.key] = ''
    if(item.key == 'status' || item.key == 'app_id' || item.key == 'customer_code' || item.key == 'role_type' || item.key == 'user_type'){
        QueryForm.formData[item.key] = null
    }
})

AddForm.formField.forEach(item=>{
    AddForm.formData[item.key] = ''
})

export {
    QueryForm,
    AddForm
}